<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
      <h4>{{sidebarHeader}}</h4>
      <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <VuePerfectScrollbar ref="sidebarScrollArea" class="vs-con-loading__container scroll-area--data-list-add-new pt-4 pb-6" :settings="settings" id="quizTaskDetails">
      <div class="pl-6 pr-6">
        <div v-if="this.$siteTypeId() != 1">
          <div>
            <label>Task Classification</label>
            <v-select class="mb-3" ref="taskClassificationTypeDropdown" placeholder="Search / Select Task Classification"  :options="taskClassificationTypeList" v-model="taskClassificationTypeText"></v-select>
          </div>
        </div>
        <div>
          <label ref="nameLabel">Name</label>
          <vs-input autocomplete="off" class="w-full mb-3" v-model="formData.name"/>
        </div>

        <div>
          <label ref="quizLabel">Quiz</label>
          <v-select ref="quizDropdown" class="w-full mb-3 style-chooser" placeholder="Search / Select Quiz" :options="quizzes" v-model="quizDropdown" @search:blur="getQuiz" @search:focus="hideElements" @input="hideElements"></v-select>
          <!-- <vs-select placeholder="Search / Select Quiz" class="w-full" vs-multiple autocomplete v-model="formData.quizId">
            <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in quizzes" />
          </vs-select> -->
        </div>

        <div>
          <vs-checkbox color="success" v-model="formData.isDecisive">Decisive</vs-checkbox>
          <div style="margin-top: 5px; margin-left: 5px;">
            <span class="text-danger text-sm" v-show="formData.isDecisive">When this is checked, students won't be allowed to do the quiz on their smart phones / tablets. It also means that pictures of the student will be taken at random intervals.</span>
          </div>
        </div>

        <div class="mt-3">
          <vs-checkbox color="success" v-model="allowOnlyOnce">Allow Only Once</vs-checkbox>
        </div>

        <div class="mt-2 vx-row" style="margin-left: 0px;" v-if="autoAssessable && quizDropdown && quiz.isGraded">
          <vs-checkbox color="success" v-model="autoAssess">Auto Assess</vs-checkbox>
          <vx-tooltip 
            text='When completing this task it will be auto assessed. Therefore, it skips the Assessment process' 
            position="bottom"
            class="info-icon-on-Auto-Assess" 
            delay=".3s">
            <feather-icon
                svgClasses="h-6 w-6"
                class="p-2 cursor-pointer"
                icon="InfoIcon"
              >
            </feather-icon>
          </vx-tooltip>
        </div>
        <span class="text-danger text-sm" v-show="autoAssessable && quizDropdown && autoAssess && !canSkip">When selecting this option mulitiple submissions after auto assessment will still be possible</span>

        <div class=" vx-row" style="margin-left: 0px;" v-if="quizDropdown">
          <vs-checkbox color="success" v-model="canSkip">Force Skip</vs-checkbox>
          <vx-tooltip 
            text='After this task is assessed you can only skip this task.' 
            position="bottom"
            class="info-icon-on-Auto-Assess" 
            delay=".3s">
            <feather-icon
                svgClasses="h-6 w-6"
                class="p-2 cursor-pointer"
                icon="InfoIcon"
              >
            </feather-icon>
          </vx-tooltip>
        </div>
        <div class="vx-row" style="margin-left: 0px;">
          <span class="text-danger text-sm" v-show="autoAssessable && quizDropdown && autoAssess && canSkip">Only one submission will be possible</span>
        </div>
        <div class=" vx-row" style="margin-left: 0px;" v-if="quizDropdown && styleB && displayBlock">
          <vs-checkbox color="success" v-model="blockOnFail">Block On Fail</vs-checkbox>
        </div>
        <div class="pt-4" style="display: inline-grid;">
          <label>Task Number</label>
          <vs-input-number class="numberinput" onClick="this.select();" v-model="formData.number" :min="styleB? 1:0" />
        </div>
        <div v-if="this.$siteTypeId() != 1">
          <vs-divider>Outcomes</vs-divider>

            <div>
              <label>Assessment Criteria</label>
              <v-select class="mb-2" ref="assessmentCriteriaDropdown" placeholder="Search / Select Assessment Criteria"  :options="assessmentCriteriaList" v-model="assessmentCriteriaText"></v-select>
            </div>
            <div>
              <label>Essential Embedded Knowledge</label>
              <v-select class="mb-2" ref="eEKDropdown" placeholder="Search / Select EEK"  :options="eekList" v-model="essentialEmbeddedKnowledgeText"></v-select>
            </div>
            <div>
              <label>Unit Standard</label>
              <v-select class="mb-2" ref="unitStandardDropdown" placeholder="Search / Select Unit Standard"  :options="unitStandardList" v-model="unitStandardText"></v-select>
            </div>
              <div>
                <label>Spesific Outcome</label>
                <v-select class="mb-2" ref="spesificOutcomeDropdown" placeholder="Search / Select Spesific Outcome"  :options="spesificOutcomeList" v-model="spesificOutcomeText"></v-select>
              </div>
        </div>
        <div v-show="isGradedQuiz  && taskGroupId==null">
          <vs-divider>Go To</vs-divider>
          <div>
            <label>On Pass</label>
            <vs-select placeholder="Search / Select Pass Task" class="w-full mb-3" vs-multiple autocomplete v-model="formData.passTaskId">
              <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in gotoList" />
            </vs-select>
            <div class="mb-3">
              <div style="margin-bottom: 8px; margin-top: 2px;">
                <vs-checkbox color="success" v-model="formData.usePassCoins">Coins</vs-checkbox>
              </div>
              <div v-if="isGradedQuiz && formData.usePassCoins">
                <div style="display: flex; margin-bottom: 8px; margin-left: 4px;">
                  <vs-switch :disabled="allowOnlyOnce" color="success" v-model="isPassCoinsRecurring">
                    <span slot="on">Recurring</span>
                    <span slot="off">Once Only</span>
                  </vs-switch>
                  <vs-switch style="margin-left: 10px;" color="success" v-model="formData.addPassCoins">
                    <span slot="on">Add</span>
                    <span slot="off">Deduct</span>
                  </vs-switch>
                </div>
                <label style="margin-left: 5px;">Coin Value</label>
                <vs-input autocomplete="off" v-validate="'numeric'" onClick="this.select();" name="Coin Value" style="margin-bottom: 5px; margin-left: 5px; width: 150px;" v-model="formData.passCoinValue" />
                <span style="margin-left: 5px;" class="text-danger text-sm" v-show="errors.has('Coin Value')">{{ errors.first('Coin Value') }}</span>
              </div>
            </div>
          </div>
          <div>
            <label>On Fail</label>
            <vs-select placeholder="Search / Select Fail Task" class="w-full mb-3" vs-multiple autocomplete v-model="formData.failTaskId">
              <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in gotoList" />
            </vs-select>
            <div>
              <div style="margin-bottom: 8px; margin-top: 2px;">
                <vs-checkbox color="success" v-model="formData.useFailCoins">Coins</vs-checkbox>
              </div>
              <div v-if="isGradedQuiz && formData.useFailCoins">
                <div style="display: flex; margin-bottom: 8px; margin-left: 4px;">
                  <vs-switch :disabled="allowOnlyOnce" color="success" v-model="isFailCoinsRecurring">
                    <span slot="on">Recurring</span>
                    <span slot="off">Once Only</span>
                  </vs-switch>
                  <vs-switch style="margin-left: 10px;" color="success" v-model="formData.addFailCoins">
                    <span slot="on">Add</span>
                    <span slot="off">Deduct</span>
                  </vs-switch>
                </div>
                <label style="margin-left: 5px;">Coin Value</label>
                <vs-input autocomplete="off" v-validate="'numeric'" onClick="this.select();" name="Coin Value" style="margin-bottom: 5px; margin-left: 5px; width: 150px;" v-model="formData.failCoinValue" />
                <span style="margin-left: 5px;" class="text-danger text-sm" v-show="errors.has('Coin Value')">{{ errors.first('Coin Value') }}</span>
              </div>
            </div>
          </div>
        </div>

        

        <div v-show="showSingleGoto  && taskGroupId == null">
          <vs-divider>Go To</vs-divider>
          <div>
            <label>On Finish</label>
            <vs-select placeholder="Search / Select Task" class="w-full pb-5" vs-multiple autocomplete v-model="formData.passTaskId">
              <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in gotoList" />
            </vs-select>
            <div class="mb-3">
              <div style="margin-bottom: 8px; margin-top: 2px;">
                <vs-checkbox color="success" v-model="formData.usePassCoins">Coins</vs-checkbox>
              </div>
              <div v-if="showSingleGoto && formData.usePassCoins">
                <div style="display: flex; margin-bottom: 8px; margin-left: 4px;">
                  <vs-switch :disabled="allowOnlyOnce" color="success" v-model="isPassCoinsRecurring">
                    <span slot="on">Recurring</span>
                    <span slot="off">Once Only</span>
                  </vs-switch>
                  <vs-switch style="margin-left: 10px;" color="success" v-model="formData.addPassCoins">
                    <span slot="on">Add</span>
                    <span slot="off">Deduct</span>
                  </vs-switch>
                </div>
                <label style="margin-left: 5px;">Coin Value</label>
                <vs-input autocomplete="off" v-validate="'numeric'" onClick="this.select();" name="Coin Value" style="margin-bottom: 5px; margin-left: 5px; width: 150px;" v-model="formData.passCoinValue" />
                <span style="margin-left: 5px;" class="text-danger text-sm" v-show="errors.has('Coin Value')">{{ errors.first('Coin Value') }}</span>
              </div>
            </div>
          </div>
        </div>

      </div>
    </VuePerfectScrollbar>

    <div class="flex flex-wrap items-center justify-center pb-4 pt-1" slot="footer">
      <vs-button class="mr-4 vs-con-loading__container cursor-pointer" color="success" @click="addEditQuizTask" :disabled="isDisabled" ref="addUpdateButton">{{buttoncaption}}</vs-button>
      <vs-button color="danger" class="mr-4 vs-con-loading__container cursor-pointer" @click="deleteApproach" v-show="formData.id" ref="deleteButton">Delete</vs-button>
      <vs-button type="border" class="ml-4 cursor-pointer" color="warning" @click="isSidebarActiveLocal = false">Cancel</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import vSelect from 'vue-select'

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    courseId: {
      type: String,
      required: true
    },
    moduleId: {
      type: String,
      required: true
    },
    nodeSelected: {
      type: Object,
      required: false
    },
    taskClassificationTypes: {
      type: Array,
      required: false
    },
    buttoncaption: {
      type: String,
      required: false
    },
    sidebarHeader: {
      type: String,
      required: false
    },
    gotoList: {
      type: Array,
      required: false
    },
    sourceTaskId: {
      type: Number,
      required: false
    },
    taskTypeList: {
      type: Array,
      required: false
    },
    taskGroupId:{
      type: Number,
      required: false
    },
    styleB: {
      type: Boolean,
      required: false
    },
    taskNumber:{
      type: Number,
      required: false
    }
  },

  data() {
    return {
      backgroundLoading:'#fff',
      formData: {
        id: 0,
        name: "",
        quizId: "",
        passTaskId: "",
        failTaskId: "",
        moduleId: "",
        sourceTaskId: 0,
        hasLogs: false,
        usePassCoins: false,
        isPassCoinsRecurring: false,
        addPassCoins: true,
        passCoinValue: "",
        useFailCoins: false,
        isFailCoinsRecurring: false,
        addFailCoins: true,
        failCoinValue: "",
        isDecisive: false,
        allowOnlyOnce: false,
        number: 0,
        standalone: false,
        spesificOutcomeId: null,
        unitStandardId: null,
        assessmentCriteriaId: null,
        essentialEmbeddedKnowledgeId: null,
        taskClassificationTypeId: null,
        taskGroupId:null,
        canSkip:true,
        autoAssess:true,
        blockOnFail:false,
      },
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.6
      },
      quizzes: [],
      quizDropdown: 0,
      isGradedQuiz: false,
      showSingleGoto: false,
      quiz: {},
      allowOnlyOnce: false,
      canSkip:true,
      autoAssess:false,
      isPassCoinsRecurring: false,
      isFailCoinsRecurring: false,
      spesificOutcomeDropdown: null,
      unitStandardDropdown: null,
      assessmentCriteriaDropdown: null,
      eEKDropdown: null,
      taskClassificationTypeDropdown: null,
      spesificOutcomeList: [],
      unitStandardList: [],
      assessmentCriteriaList: [],
      eekList: [],
      taskClassificationTypeList: [],
      spesificOutcomeText: null,
      unitStandardText: null,
      assessmentCriteriaText: null,
      essentialEmbeddedKnowledgeText: null,
      taskClassificationTypeText: null,
      autoAssessable:false,
      blockOnFail:false,
      displayBlock:false,
    };
  },
  computed: {
    isDisabled: function() {
      return !((this.formData.passTaskId|| this.taskGroupId != null) && this.quizDropdown.value );
    },
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar");
          this.initValues();
        }
      }
    },
  },
  watch: {
    allowOnlyOnce: function(val) {
      if(val){
        var self = this;
        self.isPassCoinsRecurring = false;
        self.isFailCoinsRecurring = false;
      }
    },
    isSidebarActive: function(val) {
      if(val){
        var self = this;
        var passGoToDisplayValue = 0;
        var failGoToDisplayValue = 0;
        if(self.nodeSelected.quizTask){
          passGoToDisplayValue = self.nodeSelected.quizTask.passTaskGoto;
          failGoToDisplayValue = self.nodeSelected.quizTask.failTaskGoto;
        }
        else
          passGoToDisplayValue = failGoToDisplayValue = 0;

        self.showLoadingOnElement("quizDropdown", 0.45, "corners");
        var onSuccess = response => {
          self.quizzes = response.data.map((item) => {return {label: item.text, value: item.value} });
          self.quizDropdown = self.nodeSelected.id ? self.quizzes.filter(function(item){return item.value == self.nodeSelected.quizTask.quizId;})[0] : 0;
          self.getQuiz();
        };
        var onFinally = response => {
          self.$vs.loading.close(self.$refs.quizDropdown.$el);
        }
        self.$ajaxGet(self, "quiz/getselectlist", onSuccess, onFinally);
        self.formData.moduleId = self.moduleId;
        self.taskClassificationTypeList = self.taskClassificationTypes;
        self.getEEK();
        self.getUnitStandard();
        self.getSpesificOutcome();
        self.GetAssessmentCriteria();

        if(self.nodeSelected.id){

          self.formData.id = self.nodeSelected.id;
          self.formData.name = self.nodeSelected.name;
          self.formData.sourceTaskId = self.sourceTaskId;
          self.formData.hasLogs = self.nodeSelected.quizTask.hasLogs;
          self.formData.isDecisive = self.nodeSelected.quizTask.isDecisive;
          self.allowOnlyOnce = self.nodeSelected.quizTask.allowOnlyOnce;
          self.formData.canSkip = self.nodeSelected.quizTask.canSkip;
          self.formData.autoAssess = self.nodeSelected.quizTask.autoAssess;
          self.autoAssess = self.nodeSelected.quizTask.autoAssess;
          self.canSkip = self.formData.canSkip;
          self.blockOnFail = self.nodeSelected.quizTask.blockOnFail;
          if(!self.autoAssessable){
            self.autoAssess = self.formData.autoAssess = false;
          };
          self.formData.usePassCoins = self.nodeSelected.quizTask.passCoinValue ? true : false;
          self.formData.addPassCoins = self.nodeSelected.quizTask.passCoinValue > 0 ? true : false;
          self.isPassCoinsRecurring = self.nodeSelected.quizTask.isPassCoinsRecurring;
          self.formData.passCoinValue = self.nodeSelected.quizTask.passCoinValue > 0 ? self.nodeSelected.quizTask.passCoinValue : (self.nodeSelected.quizTask.passCoinValue * -1);

          self.formData.useFailCoins = self.nodeSelected.quizTask.failCoinValue ? true : false;
          self.formData.addFailCoins = self.nodeSelected.quizTask.failCoinValue > 0 ? true : false;
          self.isFailCoinsRecurring = self.nodeSelected.quizTask.isFailCoinsRecurring;
          self.formData.failCoinValue = self.nodeSelected.quizTask.failCoinValue > 0 ? self.nodeSelected.quizTask.failCoinValue : (self.nodeSelected.quizTask.failCoinValue * -1);

          self.taskClassificationTypeText = self.taskClassificationTypeList.filter(function(item){ return item.value == self.nodeSelected.taskClassificationTypeId})[0];

          if (self.nodeSelected.number)
            self.formData.number = self.nodeSelected.number;
          else
            self.formData.number = 0;

          if(passGoToDisplayValue != 0)
            self.formData.passTaskId = self.gotoList.filter(function(item){ return item.text.split(" ")[0] == passGoToDisplayValue; })[0].value;
          if(failGoToDisplayValue != 0)
            self.formData.failTaskId = self.gotoList.filter(function(item){ return item.text.split(" ")[0] == failGoToDisplayValue; })[0].value;

        }else{
          this.initValues(self.sourceTaskId || 0);
        }
      }else {
        var scrollOptions = {
          container: '#quizTaskDetails',
          easing: 'ease-in',
          offset: -10000,
          force: true,
          cancelable: true,
          x: false,
          y: true
        }
        var cancelScroll = this.$scrollTo(this.$refs["nameLabel"], 0, scrollOptions);
      }
    },
  },
  methods: {
    getEEK(){
      var self =this;

      var onSuccess = function (response) {
        self.eekList = response.data.map(function(item) {return {value: item.value,label: item.text}});
        if(self.nodeSelected.id){
          self.essentialEmbeddedKnowledgeText = self.eekList.filter(function(item){return item.value == self.nodeSelected.essentialEmbeddedKnowledgeId})[0];
        }
      }

      self.$ajaxGet(self, "Course/EEK?courseId=" + self.courseId, onSuccess);
    },
    getUnitStandard(){
      var self =this;

      var onSuccess = function (response) {
        self.unitStandardList = response.data.map(function(item) {return {value: item.value,label: item.text}});
         if(self.nodeSelected.id){
          self.unitStandardText = self.unitStandardList.filter(function(item){return item.value == self.nodeSelected.unitStandardId})[0];
        }
      }

      self.$ajaxGet(self, "Course/UnitStandard?courseId=" + self.courseId, onSuccess);
    },
    getSpesificOutcome(){
      var self =this;

      var onSuccess = function (response) {
        self.spesificOutcomeList = response.data.map(function(item) {return {value: item.value,label: item.text}});
        if(self.nodeSelected.id){
          self.spesificOutcomeText = self.spesificOutcomeList.filter(function(item){return item.value == self.nodeSelected.spesificOutcomeId})[0];
        }
      }

      self.$ajaxGet(self, "Course/SpecificOutcome?courseId=" + self.courseId, onSuccess);
    },
    GetAssessmentCriteria(){
      var self =this;

      var onSuccess = function (response) {
        self.assessmentCriteriaList = response.data.map(function(item) {return {value: item.value,label: item.text}});
         if(self.nodeSelected.id){
          self.assessmentCriteriaText = self.assessmentCriteriaList.filter(function(item){return item.value == self.nodeSelected.assessmentCriteriaId})[0];
        }
      }

      self.$ajaxGet(self, "Course/AssesmentCriteria?courseId=" + self.courseId, onSuccess);
    },
    initValues(val) {
      this.formData.id = 0;
      this.formData.name = "";
      this.formData.sourceTaskId = 0;
      this.formData.quizId = "";
      this.formData.passTaskId = "";
      this.formData.failTaskId = "";
      this.formData.isDecisive = false;
      this.allowOnlyOnce = false;

      this.formData.usePassCoins = false;
      this.formData.addPassCoins = true;
      this.isPassCoinsRecurring = false;
      this.formData.passCoinValue = "";
      this.formData.useFailCoins = false;
      this.formData.addFailCoins = true;
      this.isFailCoinsRecurring = false;
      this.formData.failCoinValue = "";
      this.spesificOutcomeText= null;
      this.displayBlock = false;
      this.unitStandardText = null;
      this.assessmentCriteriaText = null;
      this.essentialEmbeddedKnowledgeText = null;
      this.taskClassificationTypeText = null;
      this.canSkip = true;
      this.blockOnFail = false;
      this.autoAssess = true,
      this.formData.number = this.taskNumber? this.taskNumber: 0;

      this.quizDropdown = 0;
      this.isGradedQuiz = false;
      this.showSingleGoto = false;
      this.quiz = {};
      if(val){
        this.formData.sourceTaskId = val;
      }
    
      this.errors.clear();
    },
    hideElements() {
      var self = this;
      self.isGradedQuiz = false;
      self.showSingleGoto = false;
    },
    getQuiz(){
      const self = this;
      
      var onSuccess = function(response) {
        self.quiz = response.data;
        if(self.quiz.isGraded){
          self.isGradedQuiz = true;
          self.showSingleGoto = false;
          self.displayBlock = true;
          self.autoAssessable = self.quiz.autoAssessable;
          if(self.nodeSelected){
            if(self.nodeSelected.quizTask){
              self.autoAssess = self.nodeSelected.quizTask.autoAssess;
            }
          }
        } else {
          self.isGradedQuiz = false;
          self.showSingleGoto = true;
          self.displayBlock = false;
          self.blockOnFail = false;
          self.autoAssessable = self.quiz.autoAssessable;
          self.autoAssess = false;
        }
        
      };
      var onFinally = function () {
        self.$vs.loading.close(self.$refs.sidebarScrollArea.$el);
        
      };

      if(self.quizDropdown.value){
        self.showLoadingOnSidebar();
        self.$ajaxGet(self, "Quiz/GetQuiz?quizId=" + self.quizDropdown.value, onSuccess, onFinally);
      }
    },
    saveData(val){
      this.$emit('saveData',val);
      this.$vs.loading.close(this.$refs.addUpdateButton.$el);
      this.initValues(val);
    },
    addEditQuizTask() {
      var self = this;
      if (self.styleB && !(self.spesificOutcomeText && self.spesificOutcomeText.value)) {
        self.$vs.notify({
          title:'Warning',
          color: "warning",
          text: "Please select a Specific Outcome for the task",
          position:'top-right',
          iconPack: 'feather',
          icon:'icon-slash',
          time: 5000
        });
        return;
      }

      if(!self.quiz.isGraded)
        self.formData.failTaskId = self.formData.passTaskId;

      this.$validator.validateAll().then(result => {
        if((self.formData.failTaskId)||self.taskGroupId != null){
          if (result) {
            self.showLoadingOnButton();

            self.formData.quizId = parseInt(self.quizDropdown.value);
            self.formData.allowOnlyOnce = self.allowOnlyOnce;
            self.formData.isPassCoinsRecurring = self.isPassCoinsRecurring;
            self.formData.isFailCoinsRecurring = self.isFailCoinsRecurring;
            self.formData.canSkip = self.canSkip;
            self.formData.blockOnFail = self.blockOnFail;
            self.formData.autoAssess = self.autoAssessable ? self.autoAssess : false;

            var onSuccess = response => {
              self.saveData( response.data );
              self.$vs.notify({
                title:'Information',
                color: "success",
                text: "Task Saved",
                position:'top-right',
                iconPack: 'feather',
                icon:'icon-save'
              });
            };
            var onFinally = function () {
              self.$vs.loading.close(self.$refs.addUpdateButton.$el);
            };
            self.formData.taskClassificationTypeId = self.taskClassificationTypeText ? self.taskClassificationTypeText.value: null;

            self.formData.unitStandardId = self.unitStandardText ? self.unitStandardText.value: null

            self.formData.essentialEmbeddedKnowledgeId = self.essentialEmbeddedKnowledgeText ? self.essentialEmbeddedKnowledgeText.value: null;

            self.formData.assessmentCriteriaId = self.assessmentCriteriaText ?  self.assessmentCriteriaText.value: null;

            self.formData.spesificOutcomeId = self.spesificOutcomeText ?  self.spesificOutcomeText.value: null;
            self.formData.taskGroupId = self.taskGroupId = 0 ? null: self.taskGroupId;

          	self.formData.number = self.styleB? self.formData.number >=0  ? self.formData.number: self.formData.number: self.formData.number;

          	self.$ajaxPost(self, "quiztask/addeditquiztask", self.formData, onSuccess, onFinally);
          }
        }else{
          self.$vs.notify({
              title:'Information',
              color: "warning",
              text: "Please ensure that you have selected an On Fail task",
              position:'top-right',
              iconPack: 'feather',
              icon:'icon-info'
            });
        }
      });
      var scrollOptions = {
        container: '#quizTaskDetails',
        easing: 'ease-in',
        offset: -1000,
        force: true,
        cancelable: true,
        x: false,
        y: true
      }
      var cancelScroll = this.$scrollTo(this.$refs["nameLabel"], 500, scrollOptions);
    },
    deleteTask() {
      var self = this;
      self.showLoadingOnDeleteButton();
      if(self.formData.hasLogs)
        self.showLoadingOnCytoscape();

      var onSuccess = response => {
        self.saveData();
        self.initValues();
        self.$vs.notify({
          title:'Information',
          color: "success",
          text: "Task Deleted",
          position:'top-right',
          iconPack: 'feather',
          icon:'icon-trash'
        });
      };
      var onFinally = function () {
        self.$vs.loading.close(self.$refs.deleteButton.$el);
        self.$vs.loading.close(self.$parent.$el);
      }

      self.$ajaxDelete(self, "quiztask/deletequiztask/" + self.formData.id, onSuccess, onFinally);
    },
    showLoadingOnButton(){
      var self = this;
      self.$vs.loading({
        background: self.backgroundLoading,
        type: "material",
        container: self.$refs.addUpdateButton.$el,
        scale: 0.45
      });
    },
    showLoadingOnSidebar(){
      var self = this;
      self.$vs.loading({
        background: self.backgroundLoading,
        type: "material",
        container: self.$refs.sidebarScrollArea.$el,
        scale: 1
      });
    },
    showLoadingOnDeleteButton(){
      var self = this;
      self.$vs.loading({
        background: self.backgroundLoading,
        type: "material",
        container: self.$refs.deleteButton.$el,
        scale: 0.45
      });
    },
    showLoadingOnCytoscape(){
      var self = this;
      self.$vs.loading({
        type: "corners",
        container: self.$parent.$el,
        scale: 1
      });
    },
    showLoadingOnElement(element, scale, type) {
      var self = this;
      self.$vs.loading({
        type: type,
        container: self.$refs[element].$el,
        scale: scale
      });
    },
    deleteApproach() {
      if(this.formData.hasLogs)
        this.openConfirm();
      else
        this.deleteTask();
    },
    openConfirm() {
      this.$emit("closeSidebar");
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: `Attention`,
        text: 'Are you sure you want to delete the selected Quiz task?',
        accept: this.deleteTask,
        acceptText: "Yes, delete",
        cancelText: "No, cancel"
      })
    },
  },
  components: {
    VuePerfectScrollbar,
    'v-select': vSelect
  }
};
</script>




<style lang="scss" scoped>
  .add-new-data-sidebar {
    /deep/ .vs-sidebar--background

  {
    z-index: 50010;
  }

  /deep/ .vs-sidebar {
    z-index: 50010;
    width: 400px;
    max-width: 90vw;
    .img-upload

  {
    margin-top: 2rem;
    .con-img-upload

  {
    padding: 0;
  }

  .con-input-upload {
    width: 100%;
    margin: 0;
  }

  }
  }
  }
  .info-icon-on-Auto-Assess{
    width: fit-content;
  }
  .scroll-area--data-list-add-new {
    height: calc(100% - 4.3rem);
  }
</style>
